(() => {
  if (document.documentElement.dataset.ts500GalleryReady) return;
  document.documentElement.dataset.ts500GalleryReady = 'true';
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button.slideshow-controls__thumbnail');
    if (!button) return;
    const root = button.closest('.shopify-section');
    if (!root?.querySelector('.pfp-thankshare-features')) return;
    const slideshow = button.closest('slideshow-component');
    const match = button.getAttribute('on:click')?.match(/^\/select\/(\d+)$/);
    if (!slideshow || !match || typeof slideshow.select !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    slideshow.select(Number(match[1]), undefined, { animate: false });
  }, true);
})();
